import type { SoundDesignFacets } from '../../data/sound-design.dto.ts'
import type { SoundDesignParameters } from '../models/sound-design-parameters.ts'

export const mapSoundDesignFacetsToSoundDesignFilters = (
  facet: SoundDesignFacets
): SoundDesignParameters => ({
  moods: facet['labels.as.mood.display_values'],
  genres: facet['labels.as.genre.display_values'],
  instruments: facet['labels.as.instrument.display_values'],
  bpms: facet['tags.tempo'],
})
